document.querySelectorAll('.menu-item-has-children').forEach(item => {

  const arrow = document.createElement('span');

  arrow.classList.add('submenu-toggle');
  arrow.innerHTML = 'expand_more';

  arrow.style.fontFamily = 'Google Material Icons';
  arrow.style.cursor = 'pointer';
  arrow.style.marginLeft = '5px';
  arrow.style.display = 'inline-block';
  arrow.style.transition = 'transform 0.3s ease';

  item.querySelector('a').appendChild(arrow);

  arrow.addEventListener('click', function(e){

    if (window.innerWidth >= 1281) return;

    e.preventDefault();
    e.stopPropagation();

    // Close all other open menus
    document.querySelectorAll('.menu-item-has-children.open').forEach(openItem => {
      if (openItem !== item) {
        openItem.classList.remove('open');
      }
    });

    // Toggle current menu
    item.classList.toggle('open');

  });

});